import { normalisiereUmgebung } from "@kundeninfo/ui";
import type { UmgebungsAnzeige } from "@kundeninfo/ui";
import type { SessionResponse } from "@kundeninfo/api-client";

/**
 * Die Umgebung, wie die Oberfläche sie braucht: aus der Sitzungsantwort gelesen, mit dem
 * Instanznamen aufgelöst.
 *
 * EINE SITZUNGSKONSTANTE, und deshalb wird sie GENAU EINMAL beim Start ermittelt und
 * nirgends je Route neu gerechnet: In welchem System jemand arbeitet, ändert sich
 * innerhalb einer Sitzung nicht. (Die teuer gelernte Regel dieses Projekts lautet, dass
 * kein Zustand einen Kontextwechsel überlebt — das gilt für alles, was zum Kunden, zum
 * Vorgang oder zur Ansicht gehört. Die Welt gehört zur INSTANZ und ist der Gegenfall.)
 */

/** Der Rückfall für den Instanznamen: der Hostname der aufgerufenen Seite. */
function hostnameDerSeite(): string | null {
  const name = window.location.hostname;
  return name === "" ? null : name;
}

/**
 * Liest Welt, Instanz und Konflikt aus der Sitzungsantwort.
 *
 * Der Instanzname kommt aus der Konfiguration des Servers; FEHLT er dort, setzt die
 * Oberfläche den Hostnamen der aufgerufenen Seite ein — den kennt nur sie. Der Server
 * sähe hinter dem Apache seinen eigenen (127.0.0.1) und könnte hier nichts Brauchbares
 * liefern.
 *
 * Die Welt selbst geht durch `normalisiereUmgebung`: Was nicht ausdrücklich Produktion
 * oder Entwicklung ist, ist Test — auch eine Antwort einer älteren Serverfassung, die
 * das Feld noch gar nicht kennt.
 */
export function umgebungAusSitzung(antwort: SessionResponse): UmgebungsAnzeige {
  return {
    klasse: normalisiereUmgebung(antwort.umgebung),
    instanz: antwort.instanz ?? hostnameDerSeite(),
    konflikt: antwort.konfigurationskonflikt === true,
  };
}

/** Der Name der Anwendung im Reiter — ohne jeden Zusatz. */
export const ANWENDUNGSNAME = "Kundeninfo";

/**
 * Das Präfix vor dem Seitentitel: „[TEST] " bzw. „[ENTW] ", in Produktion nichts (Spec).
 *
 * In eckigen Klammern und ganz vorn, weil ein Reiter im Browser nach wenigen Zeichen
 * abgeschnitten wird — was hinten steht, sieht bei acht offenen Reitern niemand.
 */
export function titelPraefix(anzeige: UmgebungsAnzeige): string {
  if (anzeige.klasse === "produktion") return "";
  return anzeige.klasse === "test" ? "[TEST] " : "[ENTW] ";
}
